import { themeAtom } from "../../shared/atoms";
import { NotificationM } from "../models/notifications.models";
import { Notification } from "./Notification";
import NotificationHeaderIcon from "./NotificationHeaderIcon";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {
  notifications: NotificationM[];
  isLoading: boolean;
}

const NotificationList: React.FC<Props> = ({ notifications, isLoading }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div
      className={twMerge(
        "absolute right-0 top-12 flex max-h-[440px] min-w-[400px] flex-col gap-2 overflow-y-auto rounded-lg pb-4 shadow-[0px_2px_8px_0px_#4B57592E]",
        theme.headerComponent.notifications.drawerBackground,
      )}
      style={{ zIndex: 1000 }}
    >
      <div
        data-test="notification-header"
        className={twMerge(
          "bg-s sticky left-0 top-0 z-50 flex items-center gap-2 border-b p-4 pb-2",
          theme.headerComponent.notifications.header,
          theme.headerComponent.notifications.headerBorder,
        )}
      >
        <NotificationHeaderIcon color={theme.headerComponent.notifications.headerIcon} />
        <p className={twMerge("text-[16px] font-bold", theme.headerComponent.notifications.headerText)}>
          Notifications
        </p>
      </div>

      {isLoading ? (
        <>Loading...</>
      ) : notifications.length ? (
        notifications?.map((notification) => {
          return <Notification notification={notification} key={notification.ID} />;
        })
      ) : (
        <div className="flex justify-center py-8">No Notifications</div>
      )}
    </div>
  );
};

export default NotificationList;
